import { Injectable } from "@angular/core";
import { PackagingDescription, PackagingData, RecycabilityCalculation } from "../generated/types";
import { PackagingHttpService } from "../generated/packaging-http.service";
import { ReportHttpService } from "../generated/report-http.service";
import { ArticleHttpService } from "../generated/article-http.service";

@Injectable()
export class ReportService {

  constructor(
    private packagingHttpService: PackagingHttpService,
    private reportHttpService: ReportHttpService,
    private articleHttpService: ArticleHttpService,) {
  }

  getById(id: number) {
    return this.packagingHttpService.getById(id);
  }

  post(description: PackagingDescription) {
    return this.packagingHttpService.post(description);
  }

  put(id: number, data: PackagingData) {
    return this.packagingHttpService.put(id, data);
  }

  delete(id: number) {
    return this.packagingHttpService.delete(id);
  }

  duplicate(id: number) {
    return this.packagingHttpService.duplicate(id);
  }

  getReportDebug(id: number, calculation: RecycabilityCalculation) {
    return this.reportHttpService.getDebug(id, calculation);
  }

  getReport(id: number, calculation: RecycabilityCalculation) {
    return this.reportHttpService.get(id, calculation);
  }

  getArticles(text: string) {
    return this.articleHttpService.getItems(text);
  }

  getArticle(id: number) {
    return this.articleHttpService.getById(id);
  }
}
